module.exports = __webpack_public_path__ + "static/media/menu-social.a3b3f9c2.png";